// @flow
import uuidV4 from 'uuid/v4';

// window.performance.now is in ms, with precision up to μs
// This allows us to convert to ns, and drop off the decimals.
const getTimestampNs =
  typeof window !== 'undefined' && window.performance
    ? () => Math.floor(window.performance.now() * 1000000)
    : () => Date.now() * 1000000;

type LoggerContextType = {
  view: ?number,
  viewParameter: ?number,
  component: ?number,
  element: ?number,
  objectId: ?string,
  clientTrackingParams: ?string,
};

/**
 * Creating a TimedPair object generates a UUID and logs the start time.
 * endTime is available after calling end() on the instance.
 */
class TimedPair {
  constructor(loggerContext: ?LoggerContextType) {
    this.uuid = uuidV4();

    if (loggerContext) {
      Object.assign(this, loggerContext);
    }
  }

  uuid: string;
  startTime: ?number;
  endTime: ?number;
  duration: ?number;

  view: ?number;
  viewParameter: ?number;
  component: ?number;
  element: ?number;
  objectId: ?string;
  clientTrackingParams: ?string;

  start = () => {
    this.startTime = getTimestampNs();
    return this.startTime;
  };

  // Ends the timer, returns a number for duration
  end = () => {
    this.endTime = getTimestampNs();
    this.duration = this.startTime ? this.endTime - this.startTime : null;

    return this.duration;
  };
}

export default TimedPair;
